// src/pages/PPGropus.jsx
import React, { useContext, useEffect, useState } from "react";

import Footer from "../../components/Footer";
import ProfessorGroupsReadonly from "../../components/PPanel/ProfessorGroupsReadonly";

import { UserContext } from "../../UserContext";
import { getMyGroupOverview, getMyGroupStudents } from "../../api/groupsService";

function normalizeGroupsOverview(res) {
   const groups =
      (Array.isArray(res?.groups) && res.groups) ||
      (Array.isArray(res?.data?.groups) && res.data.groups) ||
      (Array.isArray(res) && res) ||
      [];
   return groups.filter((g) => g && g.id != null);
}

function CourseGroupsList({ groups, students, status }) {
   return (
      <ProfessorGroupsReadonly
         groups={groups}
         students={students}
         status={status}
         title="Grupele mele"
      />
   );
}

function PPGropus() {
   const { user } = useContext(UserContext);

   const [status, setStatus] = useState("idle"); // idle | loading | ok | none | error
   const [groups, setGroups] = useState([]);
   const [students, setStudents] = useState([]);

   useEffect(() => {
      let cancelled = false;

      (async () => {
         if (!user?.id) return;

         if (String(user?.role).toUpperCase() !== "PROFESSOR") {
            setStatus("error");
            return;
         }

         setStatus("loading");

         try {
            const [ov, st] = await Promise.all([
               getMyGroupOverview(),
               getMyGroupStudents(),
            ]);
            if (cancelled) return;

            const list = normalizeGroupsOverview(ov);
            const studentsList = Array.isArray(st?.students) ? st.students : [];
            setGroups(list);
            setStudents(studentsList);
            if (list.length === 0 && studentsList.length === 0) setStatus("none");
            else setStatus("ok");
         } catch {
            if (cancelled) return;
            setGroups([]);
            setStudents([]);
            setStatus("error");
         }
      })();

      return () => {
         cancelled = true;
      };
   }, [user?.id, user?.role]);

   return (
      <>
       
         <main className="main">
            <section className="professor single">
               <CourseGroupsList
                  groups={groups}
                  students={students}
                  status={status}
               />
            </section>

            <Footer />
         </main>
      </>
   );
}

export default PPGropus;
